module.exports = __webpack_public_path__ + "img/success.f3c07001.png";